var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 15C36.8334 15 38.3334 16.5 38.3334 18.3333L38.3167 18.4666L38.3334 18.4833V21.6666C38.3334 22.1 38.25 22.5 38.1 22.8833L33.0667 34.6333C32.5667 35.8333 31.3834 36.6666 30 36.6666H15C13.1667 36.6666 11.6667 35.1666 11.6667 33.3333V16.6666C11.6667 15.75 12.0334 14.9166 12.65 14.3166L23.6167 3.33331L25.3834 5.08331C25.8334 5.53331 26.1167 6.16665 26.1167 6.84998L26.0667 7.38331L24.4834 15H35ZM8.33335 36.6666H1.66669V16.6666H8.33335V36.6666Z",
    fill: "#02BEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.d4f5d39ad43320b3bbe66954c4c173d1.svg";
export { ForwardRef as ReactComponent };